import { useState, useRef } from "react";
import { Upload } from "lucide-react";
import { colors } from "../../styles/theme";
import { uploadImage, updateZoomEvent } from "../../services/api";

export default function ThumbnailUpload({ event, onUpdated }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const { url } = await uploadImage(file);
      await updateZoomEvent(event.id, { thumbnailUrl: url });
      onUpdated(url);
    } catch (err) {
      alert(`Upload failed: ${err.message}`);
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 10 }}>
      {event.thumbnailUrl ? (
        <>
          <img src={event.thumbnailUrl} alt="Thumbnail" style={{ width: 48, height: 32, objectFit: "cover", borderRadius: 4, border: `1px solid ${colors.border}` }} />
          <span style={{ fontSize: 12, color: colors.textSecondary }}>Thumbnail set</span>
          <button
            onClick={() => fileRef.current?.click()}
            style={{ fontSize: 12, color: colors.info, background: "none", border: "none", cursor: "pointer", padding: 0, textDecoration: "underline" }}
          >
            {uploading ? "Uploading..." : "Change"}
          </button>
        </>
      ) : (
        <button
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 12, color: colors.textSecondary, background: "none", border: `1px dashed ${colors.border}`, borderRadius: 6, padding: "6px 12px", cursor: "pointer" }}
        >
          <Upload size={12} /> {uploading ? "Uploading..." : "Upload Thumbnail"}
        </button>
      )}
      <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp" style={{ display: "none" }} onChange={handleUpload} />
    </div>
  );
}
